import { combineReducers } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createApiActionCreators,
  createReducer,
  createActionType,
  REQUEST,
  SUCCESS,
  FAILURE,
} from '../../../common/utils/reduxHelpers';
import api  from '../api';

/**
 * ACTION TYPES
 */
export const FETCH_ACCOUNT_OVERVIEW = 'overview/FETCH_ACCOUNT_OVERVIEW'

/**
 * ACTIONS
 */

export const fetchAccountOverviewActions = createApiActionCreators(FETCH_ACCOUNT_OVERVIEW)

/**
  * REDUCERS
  */

const initialState = {
  accountOverview: null,
}

const accountOverview = createReducer(initialState.accountOverview, {
  [FETCH_ACCOUNT_OVERVIEW]: {
    [SUCCESS]: (state, payload) => payload,
    [FAILURE]: () => null,
  },
})

export default combineReducers({
  accountOverview,
})

/**
 * SELECTORS
 */
export const selectAccountOverviewState = state => state.accountOverview
export const selectAccountOverview = state => selectAccountOverviewState(state).accountOverview

/**
 * SAGAS
 */
function* fetchAccountOverview({payload}) {
  const resp = yield call(api.fetchAccountOverview, payload)

  if (resp.ok){
    yield put(fetchAccountOverviewActions.success(resp.data))
  } else {
    yield put(fetchAccountOverviewActions.failure(resp.error))
  }
}

export function* overviewSaga(){
  yield takeLatest(createActionType(FETCH_ACCOUNT_OVERVIEW, REQUEST),fetchAccountOverview)
}






// WEBPACK FOOTER //
// ./src/features/overview/ducks/index.js